import { useCallback, useEffect, useRef, useState } from 'react';
import { STUDIO_EAGER_COLUMNS, STUDIO_COLUMN_PRELOAD_MARGIN_PX } from 'src/components/star-grid/reportStudioConstants';
export const useStudioColumnVisibility = (index: number) => {
  const element = useRef<HTMLDivElement>(null);
  const [ready, setReady] = useState(index < STUDIO_EAGER_COLUMNS || typeof IntersectionObserver === 'undefined');
  const reveal = useCallback(() => setReady(true), []);
  useEffect(() => {
    if (ready || !element.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) reveal();
      },
      { root: element.current.parentElement, rootMargin: `0px ${STUDIO_COLUMN_PRELOAD_MARGIN_PX}px` }
    );
    observer.observe(element.current);
    return () => observer.disconnect();
  }, [ready, reveal]);
  return { element, ready, reveal };
};
